/**
 * Command Centre shell layout breakpoints (align with Tailwind xl = 1280px).
 * Below this width the nav sidebar is off-canvas; at/above it stays docked open.
 */
export const COMMAND_CENTRE_SIDEBAR_DOCKED_MEDIA = "(min-width: 1280px)";
